<template>
	<div>
		<CustomTable
            id_table="semence_flux_emplacement"
            ref="table"
            :items="emplacements"
            :busy.sync="table_busy"
            primaryKey="emplacementcongelation_id"
            :hide_if_empty="true"
            :hrefsRoutes="config_table_hrefs"
            :externSlotColumns="['from', 'to']"
        >
            <template v-slot:[`custom-slot-cell(from)`]="{ data }">
            	{{ data.from_localisation_label }}
            </template>
            <template v-slot:[`custom-slot-cell(to)`]="{ data }">
            	{{ data.to_localisation_label }}
            </template>
    	</CustomTable>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'EmplacementDetail',
		mixins: [Congelation],
		props: ['emplacement'],
		data () {
			return {
				config_table_hrefs: {
					'proprietaire.tiers_rs': {
						routeUniqueName: 'tiersFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'proprietaire.tiers_id'
						}
					}
				},
				table_busy: false,
				emplacements: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.emplacements = await this.getFluxEmplacement(this.emplacement.emplacementcongelation_id)
				this.table_busy = false
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>